import { StoreContext } from '../../models/store/context';

export type ConfirmationEventProperties = {
  quoteId?: string;
  itemId?: string;
  planNumber?: string;
  transactionId?: string;
  paymentType?: 'cc' | 'ach';
  offerPrice?: number;
  offerPriceAfterPromotion?: number;
  discountCode?: string;
  discountTerm?: number;
  coverStartDate?: string;
  appSessionId?: string;
  modelNumber?: string;
  applianceCategory?: string;
  guarantee?: number;
};

/**
 * Builds the commercial metadata sent alongside the upsell order confirmation event.
 *
 * @param context Current store context, read at the point the confirmation page loads.
 * @returns Event properties; individual values are undefined when their source is absent.
 */
export const getConfirmationEventProperties = (
  context: StoreContext,
): ConfirmationEventProperties => {
  const { offerData, purchaseData, applianceDetails } = context.confirmation ?? {};

  return {
    quoteId: offerData?.offerReference,
    itemId: offerData?.itemId,
    planNumber: purchaseData?.planNumber,
    transactionId: purchaseData?.transactionId,
    paymentType: purchaseData?.mappedPaymentType,
    offerPrice: purchaseData?.netFirstPaymentAmountFromPurchase ?? offerData?.netFirstPaymentAmount,
    offerPriceAfterPromotion:
      purchaseData?.netFirstPaymentAmountAfterPromotionalPeriodFromPurchase ??
      offerData?.netFirstPaymentAmountAfterPromotionalPeriod,
    discountCode: purchaseData?.discountCodeFromPurchase ?? offerData?.discountCode,
    discountTerm: purchaseData?.discountTermFromPurchase,
    coverStartDate: offerData?.startDate,
    appSessionId: context.app?.session?.id,
    modelNumber: applianceDetails?.modelNumber,
    applianceCategory: applianceDetails?.categoryName,
    guarantee: applianceDetails?.guarantee,
  };
};
